import { Post } from "../../../api/client";
import { ToastErrorStyles } from "../../../constants/toastStyles";
import { closeLoader, openLoader } from "../loader/loaderActions";
import { openToastAndSetContent } from "../toast/toastActions";

const clearcacheddata = (interval: number, clearkeys: boolean) => {
  if (!interval) return;
  clearInterval(interval);
  sessionStorage.setItem("checkout-interval-tracker", "");
  if (clearkeys) {
    sessionStorage.setItem("checkout_current_api_key", "");
    sessionStorage.setItem("checkout_current_encryption_key", "");
  }
};

export const orderStatusAction = async (payload: any, dispatch: Function, cb: Function | undefined, __window: Window | null = null) => {
  try {
    var checkoutstatus = sessionStorage.getItem("checkout-payment-completed");
    var checkoutinterval = sessionStorage.getItem(
      "checkout-interval-tracker"
    );
    const interval = Number(checkoutinterval);
    const starttime = new Date(
      sessionStorage.getItem("checkout-track-start") || new Date()
    );
    const diff = (new Date().getTime() - starttime.getTime()) / (1000 * 60);
    console.log(diff);
    if (diff > 2) {
      clearcacheddata(interval, false);
      cb && cb({ status: "time-out" })
      dispatch(closeLoader());
      return;
    }
    if (checkoutstatus === "true" && !!checkoutinterval) {
      if (interval) {
        clearcacheddata(interval, true);
      }
      return;
    }
    const res: any = await Post("/order/status", payload);
    var data = res?.data;
    console.log("Order Status", data);
    if (data?.data?.isFinalStatus) {
      sessionStorage.setItem("checkout-payment-completed", "true");
      __window?.close();
      window?.top?.postMessage(data, "*");
      cb && cb({ status: "completed" })
      dispatch(closeLoader());
    }
  } catch (error: any) {
    dispatch(closeLoader());
  }
};

export const TrackOrderStatusAction = async (payload: any, dispatch: Function, cb: Function | undefined, __window: Window | null = null) => {
  try {
    dispatch(openLoader());
    console.log("Tracking order status")
    var interval = setInterval(() => orderStatusAction(payload, dispatch, cb, __window), 1000);
    sessionStorage.setItem("checkout-interval-tracker", interval.toString());
    sessionStorage.setItem("checkout-track-start", new Date().toString());
  } catch (error: any) {
    dispatch(closeLoader());
    const message =
      error?.response?.data?.Message || error?.response?.data?.message;
    dispatch(
      openToastAndSetContent({
        toastStyles: ToastErrorStyles,
        toastContent: message,
      })
    );
  }
};

export const payOrderAction = async (payload: any, dispatch: Function, cb: Function) => {
  try {
    dispatch(openLoader());
    const data: any = await Post("order/pay", payload);
    const res = data?.data;
    cb(res);
    dispatch(closeLoader());
  } catch (error: any) {
    dispatch(closeLoader());
    const message =
      error?.response?.data?.Message || error?.response?.data?.message;
    dispatch(
      openToastAndSetContent({
        toastStyles: ToastErrorStyles,
        toastContent: message,
      })
    );
  }
};

export const trackOrderAction = async (payload: any, cb: Function) => {
  try {
    const data: any = await Post("order/event/track", payload);
    const res = data?.data;
    cb(res);
  } catch (error: any) {
    console.error(error)
  }
  return { type: "" }
};

export function openWin(redirectUrl: string) {
  const myWindow = window.open(redirectUrl, "_blank");
  return myWindow;
}

export function closeWin(__window: Window | null) {
  __window?.close();
}